import { Routes } from "@angular/router";
import { ESTUDIO_ROUTES } from './components/estudio/estudio.routes';
// import { DatosGeneralesComponent } from './pages/datos-generales/datos-generales.component';
// import { DescripcionProyectoComponent } from './pages/descripcion-proyecto/descripcion-proyecto.component';
import { DetalleEstudioComponent } from './pages/detalle-estudio/detalle-estudio.component';
import { LoginComponent } from './pages/login/login.component';
import { PrincipalComponent } from './pages/principal/principal.component';
import { UrlExternaComponent } from './pages/url-externa/url-externa.component';
// import { SeguimientoComponent } from './pages/seguimiento/seguimiento.component';

export const APP_RUTAS: Routes = [
    // { path: 'login', component: LoginComponent },
    {
        path : 'g/:uid', component:UrlExternaComponent
    },
    {
        path: 'home', component: PrincipalComponent
    },
    

    {
        // path: 'estudio/:id',
        path: 'estudio',
        component: DetalleEstudioComponent,
        children: ESTUDIO_ROUTES
    },
    // { path: 'general', component: DatosGeneralesComponent },
    // { path: 'seguimiento', component: SeguimientoComponent },
    // { path: 'proyecto', component: DescripcionProyectoComponent },
    {
        path: '', pathMatch: 'full', redirectTo: 'home'
    },
    {
        path: '**', pathMatch: 'full', redirectTo: 'home'
    },
]